import { api, ApiError } from '../api.js';

export async function renderHealth(root) {
  root.innerHTML = `
    <div class="appbar">
      <a href="/" data-link class="appbar-back" aria-label="Back">‹</a>
      <div class="appbar-title">Health</div>
    </div>

    <div class="pad">
      <div class="card" id="health-card">
        <p>Checking <code>/healthz</code>…</p>
      </div>
    </div>
  `;

  const card = document.getElementById('health-card');
  const start = performance.now();
  try {
    const data = await api('/healthz');
    const ms = Math.round(performance.now() - start);
    const pillClass = data.status === 'ok' ? 'ok' : 'warn';
    card.innerHTML = `
      <h2>
        Backend <span class="status-pill ${pillClass}">${escape(data.status)}</span>
      </h2>
      <p class="muted">round-trip: ${ms} ms</p>
      <pre>${escape(JSON.stringify(data, null, 2))}</pre>
    `;
  } catch (err) {
    const msg = err instanceof ApiError ? `${err.code || 'error'}: ${err.message}` : String(err);
    card.innerHTML = `
      <h2>Backend <span class="status-pill bad">down</span></h2>
      <pre>${escape(msg)}</pre>
    `;
  }
}

function escape(s) {
  return String(s)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}
